import { Button, CircularProgress } from '@mui/material';
import React from 'react';
import { useAxios } from '../../../../hooks/useAxios';
import { NOTIFICATION_SUBMIT_ACTION } from '../../../../api/api';
import { ACTIONS } from '../../Constants';

const ScheduleInboundActionButton = ({ actionType, actionData, handleAction }) => {
  const { callAxios: submitInboundActionCta, isLoading: isSubmittingInboundActionCta } = useAxios({
    url: NOTIFICATION_SUBMIT_ACTION,
    method: 'post',
    callOnMount: false,
  });

  return (
    <Button
      disabled={isSubmittingInboundActionCta}
      size="small"
      variant="contained"
      onClick={() => {
        submitInboundActionCta({
          data: {
            brand_id: actionData?.brand_id,
            consignment_id: actionData?.suggested_consignment_number,
            action: ACTIONS.SCHEDULE_INBOUND_CTA,
            notification_message: actionData?.notificationMessageId,
          },
        });

        handleAction(actionType, actionData);
      }}
      sx={{
        minWidth: '155px',
        whiteSpace: 'nowrap',
        background: 'white',
        color: 'var(--locad-notification-banner-default)',
        '&:hover': {
          background: 'white',
          color: 'var(--locad-notification-banner-default)',
        },
        '&.Mui-disabled': {
          background: 'white',
          color: 'var(--locad-notification-banner-default)',
          opacity: 0.9,
        },
      }}
    >
      {isSubmittingInboundActionCta ? <CircularProgress size={20} /> : 'Schedule Inbound'}
    </Button>
  );
};

export default ScheduleInboundActionButton;
